import { useState } from "react";

import { ResponsiveContainer, PieChart, Pie, Cell } from "recharts";

import { Box, Typography, useTheme } from "@mui/material";

const CnaughtPortfolioAllocationPieChart = ({
  category_allocations = [],
  selectedCategoryId,
  setSelectedCategoryId,
}) => {
  const { palette } = useTheme();

  const [hoveredCategoryId, setHoveredCategoryId] = useState(null);

  const { category: selectedCategory, allocated_fraction } =
    category_allocations.find(
      (allocation) =>
        allocation.category.id === (hoveredCategoryId || selectedCategoryId),
    ) || {};

  const { name } = selectedCategory || {};

  return (
    <ResponsiveContainer
      width="100%"
      height={300}
      style={{ position: "relative" }}
    >
      <Box
        style={{ position: "absolute", inset: 0 }}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        {selectedCategory && (
          <div>
            <Typography variant="h6" align="center" style={{ maxWidth: 150 }}>
              {name}
            </Typography>
            <Typography
              variant="subtitle2"
              align="center"
              color="textSecondary"
            >
              {Math.round(allocated_fraction * 100)}%
            </Typography>
          </div>
        )}
      </Box>
      <PieChart>
        <Pie
          data={category_allocations}
          dataKey="allocated_fraction"
          nameKey={"category.name"}
          outerRadius={150}
          innerRadius={90}
        >
          {category_allocations.map(({ category }, idx) => (
            <Cell
              key={`portfolio-allocation-pie-${idx}`}
              onMouseOver={() => setHoveredCategoryId(category.id)}
              onMouseOut={() => setHoveredCategoryId(null)}
              fill={
                selectedCategoryId === category.id
                  ? palette.secondary.main
                  : hoveredCategoryId === category.id
                    ? palette.secondary.light
                    : palette.secondary.dark
              }
              onClick={() =>
                setSelectedCategoryId?.(category_allocations[idx]?.category?.id)
              }
              style={{ cursor: "pointer" }}
            />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
};
export default CnaughtPortfolioAllocationPieChart;
